import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import 'url-search-params-polyfill';
import { User } from '../../models';
import { AuthService } from '../auth/auth.service';

interface LoginResponse {
  error: string;
  status: number | string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthBackendService {
  constructor(protected http: HttpClient, protected authService: AuthService) {}

  logout(): Observable<any> {
    return this.http.post('logout', {});
  }

  getUser(): Observable<User | null> {
    const url = 'user';
    return this.http.get<User | null>(url, {
      headers: {
        maxAge: '-1'
      }
    });
  }

  loginUser(userName: string, password: string, totpCode?: string): Observable<LoginStatus> {
    const url = 'login';
    const body = new URLSearchParams();
    body.set('username', userName);
    body.set('password', password);
    if (totpCode) {
      body.set('totpCode', totpCode);
    }
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };
    return this.http.post<LoginResponse>(url, body.toString(), options).pipe(
      map(resp => ({
          valid: resp.error === 'OK',
          mfaSetupRequired: resp.status === 'MFA_SETUP_REQUIRED'
        })
      ),
      catchError(data => {
        const errorStatus = data?.error?.status;
        const mfaRequired = data?.error?.mfaRequired === true;

        if (errorStatus === 'MFA_CODE_REQUIRED' && mfaRequired) {
          return of({ valid: false, mfaCodeRequired: true });
        }

        if (errorStatus === 'INVALID_MFA_CODE' && mfaRequired) {
          return of({ valid: false, invalidMfaCode: true });
        }

        return of({
          valid: false,
          status: data.status,
          message: data.message,
          error: typeof data.error === 'string' ? data.error.replace(/\r\n/g, '') : data.error
        });
      })
    );
  }
}

export interface LoginStatus {
  valid: boolean;
  status?: number;
  message?: string;
  error?: string;
  mfaSetupRequired?: boolean;
  mfaCodeRequired?: boolean;
  invalidMfaCode?: boolean;
}
